import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=97cac8da&scoped=true"
import script from "./Section1.vue?vue&type=script&lang=js"
export * from "./Section1.vue?vue&type=script&lang=js"
import style0 from "./Section1.vue?vue&type=style&index=0&id=97cac8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cac8da",
  null
  
)

export default component.exports